<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 grid-margin">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="mb-0">Lista documenti</h5>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive" v-if="attachments.data && attachments.data.length">
                                <paginated-table v-if="attachments.data" v-model="query" :columns="columns" :data="attachments.data" :total="attachments.total">
                                    <template slot="id" slot-scope="props">
                                        {{ props.row.id }}
                                    </template>
                                    <template slot="title" slot-scope="props">
                                        {{ props.row.title || '--' }}
                                    </template>
                                    <template slot="type" slot-scope="props">
                                        {{ props.row.type || '--' }}
                                    </template>
                                    <template slot="size" slot-scope="props">
                                        {{ props.row.size ? `${props.row.size} kb` : '--'  }}
                                    </template>
                                    <template slot="created_at" slot-scope="props">
                                        <span>{{ $date(props.row.created_at).format('DD-MM-YYYY') }}</span><br>
                                        <small><font-awesome-icon :icon="['far', 'clock']" /> {{ $date(props.row.created_at).format('hh:mm') }}</small>
                                    </template>
                                    <template slot="actions" slot-scope="props">
                                        <div class="btn-group" role="group" aria-label="">
                                            <a v-if="currentUser.type === 1" href="javascript:;" class="btn btn-sm btn-danger" @click="deleteAttachment(props.row.id)">
                                                <font-awesome-icon icon="trash-alt" /> <span>ELIMINA</span>
                                            </a>
                                            <a :href="props.row.path" class="btn btn-sm btn-info" target="_blank">
                                                <font-awesome-icon icon="link" /> <span>APRI</span>
                                            </a>
                                        </div>
                                    </template>
                                </paginated-table>
                            </div>
                            <template v-else>
                                <div class="alert alert-info mb-0">
                                    Non esistono documenti nel database.
                                </div>
                            </template>
                        </div>
                        <div class="card-footer" v-if="currentUser.type === 1">
                            <button @click="addAttachment" class="btn btn-success">
                                <font-awesome-icon icon="plus" size="sm" /> AGGIUNGI DOCUMENTO
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <document-modal />
    </section>
</template>
<script>
// import {
//     Attachment
// } from '@/models/Attachment'

import {
    mapGetters
} from 'vuex'
import {
    GET_LIST,
    DELETE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/attachments.module'
const DEFAULT_QUERY = {
    _page: 1,
    _limit: 5,
    _sort: '',
    _asc: 1
}
export default {
    name: 'documents-list',
    data () {
        return {
            columns: {
                id: {
                    label: 'ID',
                    priority: 5,
                    align: 'center'
                },
                title: {
                    label: 'Titolo documento',
                    sortable: true
                },
                type: {
                    label: 'Tipo documento',
                    priority: 3
                },
                size: {
                    label: 'Dimensione documento',
                    priority: 4
                },
                created_at: {
                    label: 'Data creazione',
                    sortable: true,
                    priority: 4
                },
                actions: {
                    label: '',
                    align: 'right'
                }
            }
        }
    },
    mounted () {
        this.fetchAttachments()
    },
    computed: {
        ...mapGetters({
            attachments: `${MODULE_NAME}/getList`
        }),
        ...mapGetters([
            'isAuthenticated',
            'currentUser'
        ]),
        query: {
            get () {
                return Object.keys(this.$route.query).length == 0 ? DEFAULT_QUERY : this.$route.query
            },
            set (new_query) {
                this.$router.replace({
                    query: {
                        ...new_query
                    }
                })
            }
        }
    },
    watch: {
        $route () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        }
    },
    methods: {
        addAttachment () {
            this.$modal.show('document-modal')
        },
        fetchAttachments () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        },
        deleteAttachment (attachmentId) {
            this.$swal({
                title: 'Sei sicuro?',
                text: 'Una volta eliminato non potrai più recuperare questo documento!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminalo!'
            }).then((willDelete) => {
                if (willDelete.value) {
                    this.$store.dispatch(`${MODULE_NAME}/${DELETE}`, attachmentId).then(() => {
                        this.fetchAttachments()
                    })
                } else {
                    this.$swal('Bene!', 'Documento salvo!')
                }
            })
        }
    },
    components: {
        PaginatedTable: () => import('@/components/PaginatedTable'),
        DocumentModal: () => import('./DocumentModal'),
    }
}
</script>
